import { BrandedNotification } from '../enums';
const MODULE_PREFIX = BrandedNotification.BRANDED_NOTIFICATION;
export const BRANDED_NOTIFICATION_SAVE_CONFIGURATION_DATA = `${MODULE_PREFIX}_SAVE_CONFIGURATION_DATA`;
export const BRANDED_NOTIFICATION_SAVE_BASE_TEMPLATE_DATA = `${MODULE_PREFIX}_SAVE_BASE_TEMPLATE_DATA`;
export const saveConfigurationDataAction = (brandedNotificationPostRequest, coCode, brandedNotificationInputs) => ({
    type: BRANDED_NOTIFICATION_SAVE_CONFIGURATION_DATA,
    payload: { brandedNotificationPostRequest, coCode, brandedNotificationInputs }
});
export const saveBaseTemplateDataAction = brandedNotificationSaveRequest => ({
    type: BRANDED_NOTIFICATION_SAVE_BASE_TEMPLATE_DATA,
    payload: brandedNotificationSaveRequest
});
//# sourceMappingURL=saveConfigurationBrandedNotificationAction.js.map